import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IFacility } from "../facilityModal";

export const getAllFacilities = createAsyncThunk(
  "Facility/FindAllFacility",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/FindAllFacility`,
        {
          CustomerName: "",
        },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createFacility = createAsyncThunk(
  "Facility/InsertFacility",
  async (FacilityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/InsertFacility`,
        FacilityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateFacility = createAsyncThunk(
  "Facility/UpdateFacility",
  async (FacilityData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/UpdateFacility`,
        FacilityData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Facility:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteFacility = createAsyncThunk(
  "Facility/DeleteFacility",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/DeleteFacility`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Facility :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getFacilityByID = createAsyncThunk(
  "Facility/FindByIDFacility",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/FindByIDFacility`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Image: result.Image,
        Description: result.Description,
        IsActive: result.IsActive ? 1 : 2,
      } as IFacility;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Certificate :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveFacility = createAsyncThunk(
  "Facility/FindAllActiveFacility",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Facility/FindAllActiveFacility`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Certificate:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveFacility = createAsyncThunk(
  "Facility/ActiveInActiveFacility",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/ActiveInActiveFacility`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Facility :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const FacilityImageUpload = createAsyncThunk(
  "Facility/FacilityImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Facility/FacilityImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Facility Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
